import { HttpClient } from '@angular/common/http';
import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Observable } from 'rxjs';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { UserCountry, UserLevel, UserDetail } from '../../../models/administration.model';
import { AdministrationService } from '../../../services/administration.service'
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material';

@Component({
    selector: 'dialog-addnewuser',
    templateUrl: 'dialog.addnewuser.html',
    styleUrls: ['./dialog.addnewuser.css']
})
export class AddNewUserDialog implements OnInit, OnDestroy {
    allSub: Subscription[] = [];
    addNewUserForm: FormGroup;
    loading: boolean = false;
    isUserValid: boolean = false;
    errorMessage: string = '';
    userDetail: UserDetail;
    database: AdministrationService | null;

    userCountry$: Observable<UserCountry[]>;
    userLevel$: Observable<UserLevel[]>;

    constructor(private http: HttpClient,
        public dialogRef: MatDialogRef<AddNewUserDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public snackBar: MatSnackBar) { }

    ngOnInit() {
        this.database = new AdministrationService(this.http);
        this.userCountry$ = this.database.getUserCountries();
        this.userLevel$ = this.database.getUserLevels();

        this.addNewUserForm = new FormGroup({
            userId: new FormControl({ value: '', disabled: false }, Validators.required),
            userCountry: new FormControl({ value: '', disabled: false }, Validators.required),
            userLevel: new FormControl({ value: '', disabled: false }, Validators.required),
            userStatus: new FormControl({ value: 'Active', disabled: true })
        });
    }

    userIdOnChange() {
        let isAdUser = this.database.getIsAdUserByAccountName(this.addNewUserForm.get('userId')!.value)
            .subscribe(
                (data) => {
                    this.loading = false;
                    if (data.status === 204) {
                        this.isUserValid = false;
                        this.openSnackBar('User Id validation failed.', '');
                    } else if (data.status === 200) {
                        switch (data.body) {
                            case true:
                                this.isUserValid = true;
                                break;
                            case false:
                                this.isUserValid = false;
                                this.openSnackBar('User Id does not exist.', '');
                                break;
                            default:
                                this.isUserValid = false;
                                break;
                        }
                    } else {
                        this.isUserValid = false;
                        this.openSnackBar('User Id validation failed.', '');
                    }
                },
                (error) => {
                    this.loading = false;
                    this.isUserValid = false;
                    this.errorMessage = <any>error;
                    this.openSnackBar(this.errorMessage, '');
                });

        //Adds into array for each subscribe
        this.allSub.push(isAdUser);
    }

    onSubmit(form: FormGroup) {
        let cfm = confirm("Are you sure you want to add new user?");

        if (cfm) {
            this.userDetail = {
                UserId: form.get('userId').value,
                CountryCode: form.get('userCountry').value,
                UserGroupCode: form.get('userLevel').value,
                UserStatusCode: form.get('userStatus').value
            }

            let update_sub = this.database.addUserDetail(this.userDetail)
                .subscribe(
                    (data) => {
                        this.loading = false;
                        if (data.status === 204) {
                            this.openSnackBar('Add new user failed.', '');
                        } else if (data.status === 200) {
                            if (data.body === 1) {
                                this.dialogRef.close('Add new user successful');
                            } else {
                                this.openSnackBar('User ID already exist.', '');
                            }
                        } else {
                            this.openSnackBar('Add new user failed.', '');
                        }
                    },
                    (error) => {
                        this.loading = false;
                        this.errorMessage = <any>error;
                        this.openSnackBar(this.errorMessage, '');
                    });

            //Adds into array for each subscribe
            this.allSub.push(update_sub);
        }
    }

    ngOnDestroy() {
        for (let sub of this.allSub) {
            sub.unsubscribe();
        }
    }

    openSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
            duration: 3000,
        });
    }
}